import styled from "@emotion/native";
import Text from "../Text";
import { ViewStyle } from "react-native";

const IMAGE_WIDTH = 170;
const ASIDE_WIDTH = 30;
const ASIDE_MARGIN_LEFT = 23;
const ASIDE_MARGIN_RIGHT = 10;
const CONTAINER_PADDING_HORIZONTAL = 12;
const IMAGE_TOP_OFFSET = 20;
const IMAGE_LEFT_OFFSET = 59;

export const Container = styled.View(
	{
		flexDirection: "row",
		alignItems: "stretch",
		marginBottom: 24,

		paddingHorizontal: CONTAINER_PADDING_HORIZONTAL,
	},
	({ imageUrl, isKnowledgeTest, isOdd }: any) => {
		let style: ViewStyle = {};

		if (imageUrl) {
			style = {
				marginTop: 28,
			};
		} else if (isKnowledgeTest) {
			style = {
				paddingHorizontal: 0,
			};
		}

		if (isOdd) {
			style = {
				...style,
				flexDirection: "row-reverse",
			};
		}

		return style;
	}
);

export const Aside = styled.View(
	{
		width: ASIDE_WIDTH,
		marginRight: ASIDE_MARGIN_RIGHT,
		paddingTop: 3,
	},
	({ isKnowledgeTest, isOdd }: any) => {
		let style: ViewStyle = {};

		if (isKnowledgeTest) {
			style = {
				marginLeft: 0,
			};
		}

		if (isOdd) {
			style = {
				...style,
				marginRight: -ASIDE_MARGIN_LEFT,
				marginLeft: ASIDE_MARGIN_LEFT + ASIDE_MARGIN_RIGHT * 2,
			};
		}

		return style;
	}
);

export const Spacer = styled.View({
	width: 15,
});

export const Main = styled.View({
	flex: 1,
});

export const Image = styled.Image({
	position: "absolute",
	width: IMAGE_WIDTH,
	height: IMAGE_WIDTH,
	left:
		0 -
		ASIDE_MARGIN_LEFT -
		CONTAINER_PADDING_HORIZONTAL -
		IMAGE_LEFT_OFFSET,
	top: 0 - IMAGE_TOP_OFFSET,
	resizeMode: "cover",
});

export const Title = styled(Text)({}, ({ isKnowledgeTest }: any) => {
	if (isKnowledgeTest) {
		return {
			marginBottom: 7,
		};
	}

	return {};
});

export const DefaultTitle = styled(Text)(
	{},
	({ imageUrl, isOdd, destination }: any) => {
		if (imageUrl) {
			const margin =
				IMAGE_WIDTH -
				ASIDE_MARGIN_LEFT -
				CONTAINER_PADDING_HORIZONTAL -
				IMAGE_LEFT_OFFSET -
				ASIDE_WIDTH -
				ASIDE_MARGIN_RIGHT +
				21;

			const marginProp = isOdd ? "marginRight" : "marginLeft";
			const oppositeMarginProp = isOdd ? "marginLeft" : "marginRight";
			const minHeight = destination ? 0 : IMAGE_WIDTH - IMAGE_TOP_OFFSET;

			return {
				[oppositeMarginProp]: 13,
				minHeight,
				[marginProp]: margin,
			};
		}

		return { padding: 2 };
	}
);

export const Body = styled(Text)(
	{},
	({ imageUrl, isOdd, destination }: any) => {
		if (imageUrl) {
			const margin =
				IMAGE_WIDTH -
				ASIDE_MARGIN_LEFT -
				CONTAINER_PADDING_HORIZONTAL -
				IMAGE_LEFT_OFFSET -
				ASIDE_WIDTH -
				ASIDE_MARGIN_RIGHT +
				21;

			const marginProp = isOdd ? "marginRight" : "marginLeft";
			const oppositeMarginProp = isOdd ? "marginLeft" : "marginRight";
			const minHeight = destination ? 0 : IMAGE_WIDTH - IMAGE_TOP_OFFSET;

			return {
				[oppositeMarginProp]: 13,
				minHeight,
				[marginProp]: margin,
			};
		}

		return { padding: 2 };
	}
);

export const BodyRichContainer = styled.View(
	{},
	({ imageUrl, isOdd, destination }: any) => {
		if (imageUrl) {
			const margin =
				IMAGE_WIDTH -
				ASIDE_MARGIN_LEFT -
				CONTAINER_PADDING_HORIZONTAL -
				IMAGE_LEFT_OFFSET -
				ASIDE_WIDTH -
				ASIDE_MARGIN_RIGHT +
				21;

			const marginProp = isOdd ? "marginRight" : "marginLeft";
			const oppositeMarginProp = isOdd ? "marginLeft" : "marginRight";
			const minHeight = destination ? 0 : IMAGE_WIDTH - IMAGE_TOP_OFFSET;

			return {
				[oppositeMarginProp]: 13,
				minHeight,
				[marginProp]: margin,
			};
		}

		return { padding: 2 };
	}
);

export const CtaTitle = styled(Text)({});

export const CtaCaption = styled(Text)({});

export const Destination = styled.View(
	{
		maxWidth: "100%",
		marginTop: 22,
		marginBottom: 51,
	},
	({ imageUrl, isOdd }: any) => {
		if (imageUrl) {
			const margin =
				IMAGE_WIDTH -
				ASIDE_MARGIN_LEFT -
				CONTAINER_PADDING_HORIZONTAL -
				IMAGE_LEFT_OFFSET -
				ASIDE_WIDTH -
				ASIDE_MARGIN_RIGHT +
				21;

			const marginProp = isOdd ? "marginRight" : "marginLeft";
			const oppositeMarginProp = isOdd ? "marginLeft" : "marginRight";

			return {
				[oppositeMarginProp]: 13,
				[marginProp]: margin,
				alignSelf: isOdd ? "flex-start" : "flex-end",
			};
		}

		return {};
	}
);
